import "./styles.css";
import AudioPlayer, {
  ActiveUI,
  InterfaceGridTemplateArea,
  PlayerPlacement,
  PlayListPlacement,
  ProgressUI,
  VolumeSliderPlacement
} from "react-modern-audio-player";
import { useState, useEffect } from "react";
  // Playlist auto-open hack removed, reverted to original state
import { playList } from "./playList";
import { playerMode } from "./playerMode";

export default function App() {
  const [progressType, setProgressType] = useState<ProgressUI>(playerMode[2].progressType);
  const [playerPlacement, setPlayerPlacement] = useState<PlayerPlacement>("static");
  const [interfacePlacement, setInterfacePlacement] = useState<InterfaceGridTemplateArea | undefined>(playerMode[2].interfacePlacement);
  const [playListPlacement, setPlayListPlacement] = useState<PlayListPlacement>(playerMode[2].playListPlacement);
  const [volumeSliderPlacement, setVolumeSliderPlacement] = useState<VolumeSliderPlacement | undefined>(playerMode[2].volumeSliderPlacement);
  const [theme, setTheme] = useState<"dark" | "light" | undefined>();
  const [width, setWidth] = useState(playerMode[2].width ?? "100%");
  const [activeUI, setActiveUI] = useState<ActiveUI>(playerMode[2].activeUI ?? { all: true });

  // Ensure mode 2 is always set on mount
  useEffect(() => {
    setInterfacePlacement(playerMode[2].interfacePlacement);
    setProgressType(playerMode[2].progressType);
    setPlayListPlacement(playerMode[2].playListPlacement);
    setVolumeSliderPlacement(playerMode[2].volumeSliderPlacement);
    setWidth(playerMode[2].width ?? "100%");
    setActiveUI(playerMode[2].activeUI ?? { all: true });
  }, []);

  return (
    <div className="App">
      <AudioPlayer
        playList={playList}
        activeUI={{
          ...activeUI,
          progress: progressType
        }}
        placement={{
          player: playerPlacement,
          interface: {
            templateArea: interfacePlacement
          },
          playList: playListPlacement,
          volumeSlider: volumeSliderPlacement
        }}
        rootContainerProps={{
          colorScheme: theme,
          width
        }}
      />
    </div>
  );
}
